﻿import React from 'react';
import {connect} from 'react-redux';

import DynamicFormErrorBox from '../../../DynamicForms/Components/DynamicFormErrorBox';
import {InformationBox} from '../../../DynamicForms/Styles/dynamicFormStyles';

import {
    pensionGuidanceCurrentStepAction,
    showAllPensionGuidanceFormErrorsAction,
    savePensionGuidanceAnswersAction
} from '../State/actions';

import {scrollToTop} from '../../../Utils/scroll';
import throttle from '../../../Utils/throttle';

class PensionGuidanceInformationBox extends React.Component {
    submitPensionGuidanceForm = (e) => {
        e.preventDefault();
        scrollToTop().then(() => {
            this.props.savePensionGuidance();
        });
    }

    validatePensionGuidance = throttle(() => {
        this.props.showAllPensionGuidanceFormErrors();
    }, 200);

    render() {
        const memberInfo = this.props.data.customer;
        const currentStep = this.props.currentStep;

        let continueButton = null
        if (currentStep === 0) {
            continueButton = (
                <div className="informationBoxBtnContainer">
                    <button
                        form="pensionGuidanceForm"
                        type="submit"
                        value="Submit"
                        className="nextStepBtn"
                        disabled={!this.props.hdStatus.valid}
                        onClick={this.submitPensionGuidanceForm}
                        onMouseEnter={this.validatePensionGuidance}
                        onTouchStart={this.validatePensionGuidance}
                    >
                        Skicka in
                    </button>
                </div>
            );
        } else if (currentStep === 1) {
            continueButton = (
                <div className="informationBoxBtnContainer">
                    <a href={this.props.data.myPagesStartUrl}>
                        <button
                            className="sendConfirmedAnswersBtn"
                        >
                            Gå till Mina sidor
                        </button>
                    </a>
                </div>
            );
        }

        return (
            <InformationBox>
                <div className="memberInfoContainer">
                    <h3>Dina uppgifter</h3>
                    <p className="memberInfoName">{memberInfo.firstName + ' ' + memberInfo.lastName}</p>
                    <p>{memberInfo.streetAddress}</p>
                    <p className="memberInfoZipCodeArea">{memberInfo.zipCodeArea}</p>
                </div>

                {!this.props.hdStatus.valid &&
                    <DynamicFormErrorBox formInputs={this.props.formInputs} />
                }

                {continueButton}
            </InformationBox>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        data: state.pensionGuidancePageData,
        currentStep: state.pageCurrentStep,
        hdStatus: state.pensionGuidanceStatus,
        formInputs: state.pensionGuidanceFormInputs
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setCurrentStep: (step) => dispatch(pensionGuidanceCurrentStepAction(step)),
        showAllPensionGuidanceFormErrors: () => dispatch(showAllPensionGuidanceFormErrorsAction()),
        savePensionGuidance: () => dispatch(savePensionGuidanceAnswersAction())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(PensionGuidanceInformationBox);
